import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getDashboardMe, getStudentInvoices } from '../../actions/usersActions'

const API_BASE = process.env.REACT_APP_DB_ADDRESS || ''

const ClockIcon = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color || '#f59e0b'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <polyline points="12 6 12 12 16 14" />
  </svg>
)

const ChartIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.3333 5.83325L11.25 12.9166L7.08332 8.74992L1.66666 14.1666" stroke="#1A1A1A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M13.3333 5.83325H18.3333V10.8333" stroke="#1A1A1A" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

const DownloadIcon = ({ size }) => (
  <svg width={size || 18} height={size || 18} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

const getJwt = () => localStorage.getItem('jwt')

const FolderIcon = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_162_3056)">
        <path d="M4.16667 3.3335H7.5L10 5.8335H15.8333C16.2754 5.8335 16.6993 6.00909 17.0118 6.32165C17.3244 6.63421 17.5 7.05814 17.5 7.50016V14.1668C17.5 14.6089 17.3244 15.0328 17.0118 15.3453C16.6993 15.6579 16.2754 15.8335 15.8333 15.8335H4.16667C3.72464 15.8335 3.30072 15.6579 2.98816 15.3453C2.67559 15.0328 2.5 14.6089 2.5 14.1668V5.00016C2.5 4.55814 2.67559 4.13421 2.98816 3.82165C3.30072 3.50909 3.72464 3.3335 4.16667 3.3335Z" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_162_3056">
        <rect width="20" height="20" fill="white"/>
        </clipPath>
        </defs>
    </svg>
)

const ClipboardIcon = () => (
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5 3H3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H13C13.5304 19 14.0391 18.7893 14.4142 18.4142C14.7893 18.0391 15 17.5304 15 17V5C15 4.46957 14.7893 3.96086 14.4142 3.58579C14.0391 3.21071 13.5304 3 13 3H11M5 3C5 2.46957 5.21071 1.96086 5.58579 1.58579C5.96086 1.21071 6.46957 1 7 1H9C9.53043 1 10.0391 1.21071 10.4142 1.58579C10.7893 1.96086 11 2.46957 11 3M5 3C5 3.53043 5.21071 4.03914 5.58579 4.41421C5.96086 4.78929 6.46957 5 7 5H9C9.53043 5 10.0391 4.78929 10.4142 4.41421C10.7893 4.03914 11 3.53043 11 3M5 10H11M5 14H11" stroke="#1A1A1A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

const CheckInCircleIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.534 6.66666C14.8385 8.16086 14.6215 9.71428 13.9192 11.0679C13.217 12.4214 12.0719 13.4934 10.675 14.1049C9.2781 14.7164 7.71376 14.8305 6.24287 14.4282C4.77199 14.026 3.48347 13.1316 2.59219 11.8943C1.70091 10.657 1.26075 9.15148 1.34511 7.62892C1.42948 6.10635 2.03326 4.65872 3.05577 3.52744C4.07829 2.39616 5.45773 1.64961 6.96405 1.4123C8.47037 1.17498 10.0125 1.46123 11.3333 2.22333" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 7.33317L8 9.33317L14.6667 2.6665" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

const ClockSmallIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4_11271)">
        <path d="M7.99998 14.6668C11.6819 14.6668 14.6666 11.6821 14.6666 8.00016C14.6666 4.31826 11.6819 1.3335 7.99998 1.3335C4.31808 1.3335 1.33331 4.31826 1.33331 8.00016C1.33331 11.6821 4.31808 14.6668 7.99998 14.6668Z" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 4V8L10.6667 9.33333" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_4_11271">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
        </defs>
    </svg>
)

const AlertIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_4_11276)">
        <path d="M8.00004 14.6668C11.6819 14.6668 14.6667 11.6821 14.6667 8.00016C14.6667 4.31826 11.6819 1.3335 8.00004 1.3335C4.31814 1.3335 1.33337 4.31826 1.33337 8.00016C1.33337 11.6821 4.31814 14.6668 8.00004 14.6668Z" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 5.3335V8.00016" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 10.6665H8.00667" stroke="#1A1A1A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_4_11276">
        <rect width="16" height="16" fill="white"/>
        </clipPath>
        </defs>
    </svg>
)

const KpiCard = ({ title, value, icon, bgColor, iconColor, loading }) => (
  <Card className='border-0 rounded-4 h-100 shadow-sm'>
    <Card.Body className='p-3 d-flex justify-content-between align-items-center'>
      <div>
        <p className='text-muted mb-1 small'>{title}</p>
        <h4 className='fw-bold text-black mb-0'>
          {loading ? <span className='bg-light rounded-3' style={{ display: 'inline-block', height: '28px', width: '80px' }} /> : (value ?? '—')}
        </h4>
      </div>
      <div className='d-flex align-items-center justify-content-center rounded-circle flex-shrink-0' style={{ width: '48px', height: '48px', backgroundColor: bgColor }}>
        {icon}
      </div>
    </Card.Body>
  </Card>
)

export default function Administration() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { dashboard, loading, invoices, invoicesLoading, documents } = useSelector(state => state.users)
    const [activeStudentIdx] = useState(0)
    const [filterTab, setFilterTab] = useState('all')

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (!dashboard) dispatch(getDashboardMe())
    }, [dispatch, dashboard])

    const students = dashboard?.students || []
    const currentStudent = students[activeStudentIdx] || null
    const enrollment = currentStudent?.odooEnrollments?.[0] || null

    useEffect(() => {
        if (currentStudent?.odooId) {
            dispatch(getStudentInvoices(currentStudent.odooId))
        }
    }, [dispatch, currentStudent?.odooId])

    const formatDate = (d) => {
        if (!d) return null
        const date = new Date(d.replace(' ', 'T') + 'Z')
        return date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })
    }

    const formatDateLong = (d) => {
        if (!d) return null
        const date = new Date(d.replace(' ', 'T') + 'Z')
        return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })
    }

    const formatDateShort = (d) => {
        if (!d) return null
        const date = new Date(d.replace(' ', 'T') + 'Z')
        return date.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })
    }

    const enrollmentStateLabel = (state) => {
        if (!state) return null
        const map = {
            active: t('administration.active'),
            done: 'Finalizada',
            cancelled: 'Cancelada',
            draft: 'Borrador',
        }
        return map[state] || state
    }

    const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return null
        return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(amount)
    }

    const now = new Date()
    const totalAmount = invoices.reduce((sum, inv) => sum + (inv.total || 0), 0)
    const paidInvoices = invoices.filter(inv => inv.paymentState === 'paid')
    const pendingInvoices = invoices.filter(inv => inv.paymentState !== 'paid')
    const overdueInvoices = pendingInvoices.filter(inv => inv.dueDate && new Date(inv.dueDate.replace(' ', 'T') + 'Z') < now)
    const paidAmount = paidInvoices.reduce((sum, inv) => sum + (inv.total || 0), 0)
    const paidCount = paidInvoices.length
    const pendingCount = pendingInvoices.length
    const overdueCount = overdueInvoices.length
    const progressPercent = totalAmount > 0 ? Math.round((paidAmount / totalAmount) * 100) : 0
    const nextPayment = pendingInvoices.filter(inv => !overdueInvoices.some(o => o.id === inv.id)).sort((a, b) => (a.dueDate || '') < (b.dueDate || '') ? -1 : 1)[0] || null

    const filteredInvoices = filterTab === 'all' ? invoices
        : filterTab === 'paid' ? paidInvoices
        : filterTab === 'pending' ? pendingInvoices.filter(inv => !overdueInvoices.some(o => o.id === inv.id))
        : filterTab === 'overdue' ? overdueInvoices
        : invoices

    const filterTabs = [
        { key: 'all', label: `${t('administration.all')} (${invoices.length})`, icon: null },
        { key: 'paid', label: `${t('administration.paidtab')} (${paidCount})`, icon: <CheckInCircleIcon /> },
        { key: 'pending', label: `${t('administration.pendingtab')} (${pendingCount - overdueCount})`, icon: <ClockSmallIcon /> },
        { key: 'overdue', label: `${t('administration.overdue')} (${overdueCount})`, icon: <AlertIcon /> },
    ]

    const stateBadge = (inv) => {
        if (inv.paymentState === 'paid') {
            return <span className='invoice-badge badge-paid'>{t('administration.paidbadge')}</span>
        }
        const overdue = inv.dueDate && new Date(inv.dueDate.replace(' ', 'T') + 'Z') < now
        if (overdue) {
            return <span className='invoice-badge badge-overdue'>{t('administration.overduebadge')}</span>
        }
        return <span className='invoice-badge badge-pending'>{t('administration.pendingbadge')}</span>
    }

    return (
        <Container className='my-3 p-5'>
            <Row>
                <Col>
                    <h2 className='fw-bold mb-1' style={{ color: '#222', fontSize: '32px' }}>{t('administration.title')}</h2>
                    <p className='text-muted' style={{ fontSize: '15px' }}>{t('administration.subtitle')}</p>
                </Col>
            </Row>

            {!dashboard && loading ? (<>
                <Row className='g-3 mt-3'>
                    {[1,2,3,4].map(i => (
                        <Col key={i} xs={6} md={3}>
                            <Card className='border-0 rounded-4 h-100'>
                                <Card.Body className='p-3'>
                                    <div className='bg-light rounded-3' style={{ height: '12px', width: '60%' }} />
                                    <div className='bg-light rounded-3 mt-2' style={{ height: '24px', width: '40%' }} />
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <Row className='mt-4 g-4'>
                    <Col xs={12} lg={8}>
                        <Card className='border-0 rounded-4'>
                            <Card.Body className='p-4'>
                                <div className='bg-light rounded-3' style={{ height: '20px', width: '180px' }} />
                                <div className='bg-light rounded-3 mt-3' style={{ height: '14px', width: '100%' }} />
                                <div className='bg-light rounded-3 mt-2' style={{ height: '10px', width: '100%' }} />
                                <div className='bg-light rounded-3 mt-4 p-4' style={{ height: '80px', width: '100%' }} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} lg={4}>
                        <Card className='border-0 rounded-4'>
                            <Card.Body className='p-4'>
                                <div className='bg-light rounded-3' style={{ height: '20px', width: '140px' }} />
                                <div className='bg-light rounded-3 mt-3' style={{ height: '14px', width: '80px' }} />
                            </Card.Body>
                        </Card>
                        <Card className='border-0 rounded-4 mt-4'>
                            <Card.Body className='p-4'>
                                <div className='bg-light rounded-3' style={{ height: '20px', width: '140px' }} />
                                <div className='bg-light rounded-3 mt-4' style={{ height: '14px', width: '100%' }} />
                                <div className='bg-light rounded-3 mt-2' style={{ height: '14px', width: '100%' }} />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                </> ) : (<>

            <Row className='g-3 mt-2'>
                <Col xs={6} md={3}>
                    <KpiCard
                        title={t('administration.totalamount')}
                        value={formatCurrency(totalAmount)}
                        loading={invoicesLoading}
                        icon={<img src="/images/creditcard.svg" alt="total" width={22} style={{ filter: 'invert(35%) sepia(98%) saturate(748%) hue-rotate(202deg) brightness(94%) contrast(101%)' }} />}
                        bgColor='#eff6ff'
                        iconColor='#2563eb'
                    />
                </Col>
                <Col xs={6} md={3}>
                    <KpiCard
                        title={t('administration.monthlyfee')}
                        value={invoicesLoading ? null : (invoices[0]?.total ? formatCurrency(invoices[0].total) : '—')}
                        loading={invoicesLoading}
                        icon={<img src="/images/calendar.svg" alt="monthly" width={20} style={{ filter: 'invert(47%) sepia(95%) saturate(3925%) hue-rotate(330deg) brightness(98%) contrast(95%)' }} />}
                        bgColor='#fef2f2'
                        iconColor='#ec4899'
                    />
                </Col>
                <Col xs={6} md={3}>
                    <KpiCard
                        title={t('administration.paidfees')}
                        value={invoicesLoading ? null : `${paidCount}`}
                        loading={invoicesLoading}
                        icon={<img src="/images/check.svg" alt="paid" width={22} style={{ filter: 'invert(47%) sepia(79%) saturate(634%) hue-rotate(92deg) brightness(97%) contrast(94%)' }} />}
                        bgColor='#f0fdf4'
                        iconColor='#22c55e'
                    />
                </Col>
                <Col xs={6} md={3}>
                    <KpiCard
                        title={t('administration.pendingfees')}
                        value={invoicesLoading ? null : `${pendingCount}`}
                        loading={invoicesLoading}
                        icon={<ClockIcon color='#f59e0b' />}
                        bgColor='#fffbeb'
                        iconColor='#f59e0b'
                    />
                </Col>
            </Row>

            <Row className='mt-4 g-4'>
                <Col xs={12}>
                    <Card className='invoice-card mb-4'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center gap-2 mb-1'>
                                <ChartIcon />
                                <h5 className='fw-bold text-black mb-0'>{t('administration.paymentprogress')}</h5>
                            </div>
                            <p className='text-muted mb-3' style={{ fontSize: '14px' }}>
                                {invoicesLoading ? '—' : `Has pagado ${formatCurrency(paidAmount)} de ${formatCurrency(totalAmount)} en total`}
                            </p>
                            <div className='mb-1'>
                                <div className='d-flex justify-content-between mb-2 align-items-center'>
                                    <span className='text-muted small'>{t('administration.paid')}: {invoicesLoading ? '—' : formatCurrency(paidAmount)}</span>
                                    <span className='text-muted small'>{progressPercent}% completado</span>
                                </div>
                                <div style={{ height: '10px', borderRadius: '10px', background: '#f3f4f6', overflow: 'hidden' }}>
                                    <div style={{ height: '100%', width: Math.min(progressPercent, 100) + '%', background: '#f97316', borderRadius: '10px', transition: 'width 0.5s ease' }} />
                                </div>
                            </div>

                            {nextPayment && (
                                <Card className='border-0 rounded-3 mt-4' style={{ backgroundColor: '#eff6ff' }}>
                                    <Card.Body className='p-3'>
                                        <p className='text-muted mb-1 small'>{t('administration.nextpayment')}</p>
                                        <h4 className='fw-bold text-black mb-1'>{formatCurrency(nextPayment.total)}</h4>
                                        <p className='text-muted mb-0 small'>{t('administration.duedate')}: {nextPayment.dueDate ? formatDateLong(nextPayment.dueDate) : '—'}</p>
                                    </Card.Body>
                                </Card>
                            )}
                        </Card.Body>
                    </Card>

                    {invoices.length > 0 && (
                        <>
                            <div className='d-flex gap-2 mb-2 invoice-filters'>
                                {filterTabs.map(tab => (
                                    <button
                                        key={tab.key}
                                        onClick={() => setFilterTab(tab.key)}
                                        className={`rounded-pill invoice-filter-btn d-inline-flex align-items-center gap-1 border-0 px-3 py-1 ${filterTab === tab.key ? 'active' : ''}`}
                                    >
                                        {tab.icon && <span className='d-flex'>{tab.icon}</span>}
                                        {tab.label}
                                    </button>
                                ))}
                            </div>

                            <Card className='invoice-card'>
                                <Card.Body className='p-0'>
                                    <div className='table-responsive invoice-table-wrapper'>
                                        <table className='invoice-table'>
                                            <thead>
                                                <tr>
                                                    <th className='col-number'>{t('administration.number')}</th>
                                                    <th className='col-desc'>{t('administration.description')}</th>
                                                    <th className='col-date'>{t('administration.date')}</th>
                                                    <th className='col-due'>{t('administration.expiration')}</th>
                                                    <th className='col-amount'>{t('administration.amount')}</th>
                                                    <th className='col-status'>{t('administration.status')}</th>
                                                    <th className='col-actions'>{t('administration.actions')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {filteredInvoices.map(inv => (
                                                    <tr key={inv.id} className='invoice-row'>
                                                        <td className='cell-number' data-label={t('administration.number')}>
                                                            <span className='invoice-name'>{inv.name}</span>
                                                        </td>
                                                        <td className='cell-desc' data-label={t('administration.description')}>
                                                            <span className='invoice-desc'>{inv.description}</span>
                                                            {inv.descriptionLine2 && <span className='invoice-desc-sub'>{inv.descriptionLine2}</span>}
                                                        </td>
                                                        <td className='cell-date' data-label={t('administration.date')}>
                                                            <span>{inv.date ? formatDateShort(inv.date) : '—'}</span>
                                                        </td>
                                                        <td className='cell-due' data-label={t('administration.expiration')}>
                                                            <span>{inv.dueDate ? formatDateShort(inv.dueDate) : '—'}</span>
                                                        </td>
                                                        <td className='cell-amount' data-label={t('administration.amount')}>
                                                            <span className='invoice-amount'>{formatCurrency(inv.total)}</span>
                                                        </td>
                                                        <td className='cell-status' data-label={t('administration.status')}>
                                                            {stateBadge(inv)}
                                                        </td>
                                                        <td className='cell-actions' data-label={t('administration.actions')}>
                                                            <a href={`${API_BASE}/api/dashboard/invoice-download?invoiceId=${inv.id}&partnerId=${inv.partnerId || ''}&token=${getJwt()}`} target='_blank' rel='noopener noreferrer' className='invoice-download-link' title={t('administration.download')}>
                                                                <DownloadIcon />
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {filteredInvoices.length === 0 && (
                                                    <tr>
                                                        <td colSpan={7} className='text-center text-muted py-4'>&mdash;</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </>
                    )}
                    {invoices.length === 0 && !invoicesLoading && (
                        <p className='text-center text-muted py-4 mb-0'>&mdash;</p>
                    )}
                </Col>

                <Col xs={12} lg={6}>
                    <Card className='enrollment-card mb-4'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center gap-2 mb-4'>
                                <ClipboardIcon />
                                <h5 className='fw-bold text-black mb-0'>{t('administration.enrollment')}</h5>
                            </div>
                            <div className='enrollment-grid'>
                                <div className='enrollment-field'>
                                    <span className='enrollment-label'>{t('academic.course')}</span>
                                    <span className='enrollment-value'>{enrollment?.courseName || '—'}</span>
                                </div>
                                <div className='enrollment-field'>
                                    <span className='enrollment-label'>{t('administration.enrollmentstatus')}</span>
                                    <span className='enrollment-value'>
                                        <span className='enrollment-badge enrollment-badge-active'>{enrollmentStateLabel(enrollment?.state) || '—'}</span>
                                    </span>
                                </div>
                                <div className='enrollment-field'>
                                    <span className='enrollment-label'>{t('academic.group')}</span>
                                    <span className='enrollment-value'>{enrollment?.groupName || '—'}</span>
                                </div>
                                <div className='enrollment-field'>
                                    <span className='enrollment-label'>{t('academic.modality')}</span>
                                    <span className='enrollment-value'>{enrollment?.modality || '—'}</span>
                                </div>
                                <div className='enrollment-field'>
                                    <span className='enrollment-label'>Sede</span>
                                    <span className='enrollment-value'>{enrollment?.sessions?.[0]?.campusName || '—'}</span>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col xs={12} lg={6}>
                    <Card className='border-0 rounded-4 shadow-sm'>
                        <Card.Body className='p-4'>
                            <div className='d-flex align-items-center gap-2 mb-3'>
                                <FolderIcon />
                                <h5 className='fw-bold text-black mb-0'>{t('administration.documents')}</h5>
                            </div>
                            {documents?.length > 0 ? documents.map(doc => (
                                <a key={doc.id} href={`${API_BASE}${doc.url}&token=${getJwt()}`} target='_blank' rel='noopener noreferrer' className='text-decoration-none'>
                                    <div className='d-flex align-items-center gap-3 border rounded-3 p-3 mb-2'>
                                        <div className='d-flex align-items-center justify-content-center rounded-3 flex-shrink-0' style={{ width: '40px', height: '40px', backgroundColor: '#F3F4F6' }}>
                                            <img src="/images/document.svg" alt="pdf" width={18} />
                                        </div>
                                        <div className='flex-grow-1'>
                                            <p className='fw-semibold mb-0 small text-black'>{doc.name}</p>
                                            <p className='text-muted mb-0' style={{ fontSize: '12px' }}>
                                                {doc.date ? formatDate(doc.date) : ''}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            )) : (
                                <p className='text-muted text-center py-3'>&mdash;</p>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            </>)}
        </Container>
    )
}